module.exports = __webpack_public_path__ + "static/media/financials-expense-chart.0800a70a.svg";